// removed by extract-text-webpack-plugin
module.exports = {"main":"number-display-main--1_Kkj","status-ok":"number-display-status-ok--2tOLr","status-warning":"number-display-status-warning--1BdNR","status-problem":"number-display-status-problem--1xH3-","status-disconnected":"number-display-status-disconnected--1Yb_V","value":"number-display-value--3wFmw","unit":"number-display-unit--17_DL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NumberDisplay/number-display.scss
// module id = k+jW
// module chunks = 4